var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"saul-metas-app"}},[_c('loader-component'),_c(_vm.layout,{tag:"component"},[_c('router-view',{key:_vm.$route.fullPath,scopedSlots:_vm._u([{key:"default",fn:function({ Component }){return [_c('transition',{attrs:{"name":"fade"}},[_c(Component,{tag:"component"})],1)]}}])})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }